import React, { useState } from 'react';
import Breadcrumbs, { Crumb } from 'components/ui/Breadcrumbs';
import { useSelector } from 'react-redux';
import { Link } from 'react-feather';

const Topbar = () => {
  const { title, id } = useSelector(state => state);
  const [showLinkCopied, updateShowLinkCopied] = useState(false);

  return (
    <div className="JourneyReporting-topBar">
      <Breadcrumbs
        parentUrl="/content"
        parentTitle={t('journeys.builder.content')}
        className="mr-24 mt-1 mb-1"
      >
        <Crumb>{title}</Crumb>
      </Breadcrumbs>
      <button
        type="button"
        className="JourneyBuilderTopbar-share"
        onClick={() => {
          navigator.clipboard.writeText(
            `https://${window.location.hostname}/journey/${id}`,
          );
          updateShowLinkCopied(true);

          setTimeout(() => {
            updateShowLinkCopied(false);
          }, 2000);
        }}
      >
        <>
          {/* eslint-disable-next-line */}
          <Link size={16} />
          {showLinkCopied
            ? t('journeys.builder.link_copied')
            : t('journeys.builder.share_link')}
        </>
      </button>
    </div>
  );
};

export default Topbar;
